/** Regras de anexo no webapp, espelhando o que o backend e a Cloud API do WhatsApp aceitam. */

export type AttachmentTarget = "ticket" | "whatsapp";

const MB = 1024 * 1024;
export const TICKET_MAX_BYTES = 25 * MB;
export const WHATSAPP_MAX_BYTES = { image: 5 * MB, video: 16 * MB, audio: 16 * MB, document: 25 * MB } as const;

const WHATSAPP_IMAGE_MIMES = new Set(["image/jpeg", "image/png"]);

function whatsappKind(mime: string): keyof typeof WHATSAPP_MAX_BYTES {
	if (mime.startsWith("image/")) return "image";
	if (mime.startsWith("video/")) return "video";
	if (mime.startsWith("audio/")) return "audio";
	return "document";
}

/** Devolve a mensagem de erro (pt-BR) se o arquivo não pode ser anexado, ou null se está ok. */
export function validateAttachment(file: { name: string; type: string; size: number }, target: AttachmentTarget): string | null {
	if (file.size === 0) return `"${file.name}" está vazio.`;
	if (target === "ticket") {
		return file.size > TICKET_MAX_BYTES ? `"${file.name}" passa do limite de ${TICKET_MAX_BYTES / MB} MB.` : null;
	}
	const kind = whatsappKind(file.type);
	if (kind === "image" && !WHATSAPP_IMAGE_MIMES.has(file.type)) {
		return `"${file.name}": o WhatsApp só aceita imagem JPEG ou PNG.`;
	}
	if (file.size > WHATSAPP_MAX_BYTES[kind]) {
		return `"${file.name}" passa do limite do WhatsApp para ${kind === "image" ? "imagem" : kind === "document" ? "documento" : kind} (${WHATSAPP_MAX_BYTES[kind] / MB} MB).`;
	}
	return null;
}

export function partitionFiles<T extends { name: string; type: string; size: number }>(files: T[], target: AttachmentTarget) {
	const accepted: T[] = [];
	const errors: string[] = [];
	for (const f of files) {
		const err = validateAttachment(f, target);
		if (err) errors.push(err);
		else accepted.push(f);
	}
	return { accepted, errors };
}
